import React from 'react';

const Home = () => (
  <section id="home" className="min-h-screen flex items-center justify-center bg-light-theme-color dark:bg-gray-800 text-gray-800 dark:text-white transition-colors duration-300">
    <div className="text-center space-y-4">
      <h1 className="text-5xl font-bold">Hi, I'm Vraj Shah</h1>
      <p className="text-xl">Software Developer | Android & iOS Enthusiast</p>
    </div>
  </section>
);

export default Home;
